import React, { useContext, useCallback } from 'react';
import { IModifiersContext, ModifiersContext } from '../modifiersState/modifiersContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalSelectCustomer } from 'components/ModalWindows/ModalSelectCustomer';
import { ModalAssignModifierToRestaurants } from 'components/ModalWindows/ModalAssignModifierToRestaurants';
import { ModalEditNestedModGroupTemplate } from 'components/ModalWindows/ModalEditNestedModGroupTemplate';

export const ModalWindows: React.FC = () => {
	const {
		refetchData,
		deleteSelectedItem,
		changeTypeOfModalWindow,
		setIDCustomer,
		toggleRememberMyChoice,
		rememberMyChoice,
		typeOfModalWindow,
		IDSelectedCustomer,
		IDForAssignRestaurants,
		IDForEditModGroupTemplate,
		isInitializedSelectCustomerModal,
	} = useContext<IModifiersContext>(ModifiersContext);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, [changeTypeOfModalWindow]);

	const handleCloseModalWithRefetch = useCallback(() => {
		changeTypeOfModalWindow(null);
		refetchData(true);
	}, [changeTypeOfModalWindow]);

	const handleCloseModalWithError = useCallback(() => {
		changeTypeOfModalWindow('errorUpdatingModifier');
	}, [changeTypeOfModalWindow]);

	const handleCloseModifierHasPortionsError = useCallback(() => {
		changeTypeOfModalWindow('errorModifierHasPortions');
	}, [changeTypeOfModalWindow]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow || !IDSelectedCustomer}>
			{typeOfModalWindow === 'toConfirmDeleteItem' && (
				<ModalToConfirm
					onConsentEvent={deleteSelectedItem}
					onFailureEvent={handleCloseModal}
					isVisible={true}
					description="deleteModifier"
					typeOfInfoIcon="toDelete"
				/>
			)}
			{typeOfModalWindow === 'success' && (
				<ModalSentSuccessfully
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="deleteModifierSuccessfully"
				/>
			)}
			{typeOfModalWindow === 'error' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorWhileDeletingModifier"
				/>
			)}
			{typeOfModalWindow === 'errorUpdatingModifier' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorUpdatingModifier"
				/>
			)}
			{!IDSelectedCustomer && isInitializedSelectCustomerModal && (
				<ModalSelectCustomer
					setIDCustomer={setIDCustomer}
					toggleRememberMyChoice={toggleRememberMyChoice}
					rememberMyChoice={rememberMyChoice}
				/>
			)}
			{typeOfModalWindow === 'assignRestaurants' && IDForAssignRestaurants && (
				<ModalAssignModifierToRestaurants
					onFailureEvent={handleCloseModal}
					onCloseModal={handleCloseModalWithRefetch}
					onShowError={handleCloseModalWithError}
					modifierId={IDForAssignRestaurants}
				/>
			)}
			{typeOfModalWindow === 'editNestedModGroupTemplate' && IDForEditModGroupTemplate && (
				<ModalEditNestedModGroupTemplate
					onFailureEvent={handleCloseModal}
					onCloseModal={handleCloseModalWithRefetch}
					onShowError={handleCloseModalWithError}
					onShowProductHasPortionsError={handleCloseModifierHasPortionsError}
					modifierId={IDForEditModGroupTemplate}
				/>
			)}
			{typeOfModalWindow === 'errorModifierHasPortions' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorModifierHasPortions"
				/>
			)}
		</ModalWrapper>
	);
};
